export default {
  computed: {
    isPizzaheinz () {
      return window.type === 'pizzaheinz'
    },

    isFoodi () {
      return window.type === 'foodi'
    },

    isPosApp () {
      return window.type === 'pos'
    },

    isStrandbutler () {
      return window.type === 'strandbutler'
    },

    isCustomerWebsite () {
      return window.type === 'customer'
    },

    logo () {
      if (this.isFoodi) {
        return '/static/foodi.svg'
      }

      if (this.isStrandbutler) {
        return '/static/strandbutler.svg'
      }

      if (this.isCustomerWebsite) {
        return false
      }
    },

    logoText () {
      if (this.isPizzaheinz) {
        return '* heißt bald foodi.de 🔥'
      }

      return ''
    },

    company () {
      let data = {
        name: 'foodi.de GmbH',
        street: 'Aubachstraße 6',
        city: '56410 Montabaur',
        url: 'https://foodi.de',
        mail: 'info@foodi.de',
        tax: 'DE281067227',
        ceo: 'Christian Scherer',
        registration: 'HRB 22910 AG Montabaur',
        phone: '01573 598 40 60'
      }

      if (this.isStrandbutler) {
        data = {
          name: 'Strand & Mehr GmbH',
          street: 'St. Annenufer 2',
          city: '20457 Hamburg',
          url: 'https://strandbutler.de',
          mail: 'moin@strandbutler.de',
          tax: 'DE338544284',
          ceo: 'Bernhard Sourdeau',
          registration: 'HRB 166661 AG Hamburg',
          phone: '040 22857860'
        }
      }

      return data
    },

    instagram () {
      if (this.isCustomerWebsite) {
        return false
      } else {
        return 'https://www.instagram.com/' + this.instagramName
      }
    },

    instagramName () {
      if (this.isCustomerWebsite) {
        return false
      }

      if (this.isStrandbutler) {
        return 'https://www.instagram.com/strandbutler/'
      }

      return 'foodi.de'
    },

    facebook () {
      if (this.isCustomerWebsite) {
        return false
      }

      if (this.isStrandbutler) {
        return 'https://www.facebook.com/strandbutler/'
      }

      return 'https://www.facebook.com/www.foodi.de'
    },

    site () {
      let domain = 'foodi.de'

      if (this.isStrandbutler) {
        domain = 'strandbutler.menu'
      }

      return {
        title: (window.baseTitle === null ? '' : window.baseTitle),
        logo: this.logo,
        domain: domain
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/sites.js